export default "__VITE_ASSET__SathjDbb__"